(function () {
    function currencyFilter(LocalisationService) {
        return function (input) {

            // If the input is undefined or null, we return undefined|null so that bind once continues to bind until the value is not null.
            if (input === null || typeof input === "undefined") {
                return input;
            }

            return LocalisationService.formatCurrency(input);
        };
    }

    angular
        .module('dashboard')
        .filter('customCurrency', [ 'LocalisationService', currencyFilter ]);
})();
